'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".LineLogo-module_lineLogo__fk7eu{width:3rem}";
var styles = {"lineLogo":"LineLogo-module_lineLogo__fk7eu"};
styleInject["default"](css_248z, '02ced6dd-e0a4-462f-a19a-2dfd84eefb71');

exports["default"] = styles;
